import { NativeCurrencyBase } from '../hooks/useNativeCurrency'
import { ChainWithRpcUrl } from './networks'

export type NetworkType =
  | 'Ethereum'
  | 'Rollup'
  | 'AnyTrust'
  | 'Ethereum Testnet'
  | 'Arbitrum Testnet'

export type BridgeUiConfig = {
  color: `#${string}`
  network: {
    name: string
    logo: string
    description?: string
  }
  nativeTokenData?: NativeCurrencyBase
}

type OrbitChainConfig = ChainWithRpcUrl & { bridgeUiConfig: BridgeUiConfig }

export const orbitMainnets: {
  [key: number]: OrbitChainConfig
} = {}

export const orbitTestnets: { [key in number]: OrbitChainConfig } = {
  66238: {
    chainID: 66238,
    name: 'OMAChain Testnet',
    explorerUrl: 'https://explorer.testnet.chain.oma3.org/',
    tokenBridge: {
      l1CustomGateway: '0xDDe07fA1fDB70f3590c9AbC1Ade15e40bC3a9ECa',
      l1ERC20Gateway: '0x82eddb7b270167d5049e449998c2E8935F0fabC4',
      l1GatewayRouter: '0x5F5F57c9840af93994fC688991b578A86e34df36',
      l1MultiCall: '0x73465577E9FD7Cd585E4270F23A9eBa99B92b6eD',
      l1ProxyAdmin: '0x98d82acb53ce43F0C3A9eEBf8cE9533996967BF8',
      l1Weth: '0x0000000000000000000000000000000000000000',
      l1WethGateway: '0x0000000000000000000000000000000000000000',
      l2CustomGateway: '0xbd21Fb76F22E8e6a457f6DE0fcDdaa95E6558Cef',
      l2ERC20Gateway: '0x806976EbF46d8B978faC1E03c2858c7bB42dBC52',
      l2GatewayRouter: '0x88F5AA18A44dDB41656C11f29Fa88dbbC158D1D7',
      l2Multicall: '0x71c32053895517A46f4c1E9d045b7B6FaBCB5F4F',
      l2ProxyAdmin: '0x3CCEF93f6da129f047C9C1644c6aE8c5aDC2cDFD',
      l2Weth: '0x0000000000000000000000000000000000000000',
      l2WethGateway: '0x0000000000000000000000000000000000000000'
    },
    ethBridge: {
      bridge: '0xD34E78b6F7666ACC4749B160E9CD15063103B086',
      inbox: '0x4bab6f02A3c5b9B265d413B5A16F098dA7D28bB5',
      outbox: '0x59F8BFd0a8926786Ca3f0aE1deF395193E68b91E',
      rollup: '0x24dD6c393ebAa087d4274d8269Ff12Fba96b0b3b',
      sequencerInbox: '0xF54DeB0341FAC9E8f649CA8Dc119f697f14B868f'
    },
    isArbitrum: true,
    isCustom: true,
    partnerChainID: 11155111,
    partnerChainIDs: [],
    retryableLifetimeSeconds: 604800,
    nitroGenesisBlock: 0,
    nitroGenesisL1Block: 0,
    depositTimeout: 900000,
    confirmPeriodBlocks: 600,
    blockTime: 0.25,
    nativeToken: '0xd7ee0eADb283eFB6d6e628De5E31A284183f4EDf',
    rpcUrl: 'https://rpc.testnet.chain.oma3.org/',
    slug: 'OMA',
    bridgeUiConfig: {
      color: '#49bcfc',
      network: {
        name: 'OMAChain Testnet',
        logo: '/logo.svg',
        description: 'Testnet chain for Orbit deployment'
      },
      nativeTokenData: {
        name: 'OMA',
        symbol: 'OMA',
        decimals: 18,
        logoUrl: '/logo.svg'
      }
    }
  }
}

export const orbitChains = { ...orbitMainnets, ...orbitTestnets }

export function getOrbitChains(
  {
    mainnet,
    testnet
  }: {
    mainnet: boolean
    testnet: boolean
  } = { mainnet: true, testnet: true }
): OrbitChainConfig[] {
  const mainnetChains = mainnet ? Object.values(orbitMainnets) : []
  const testnetChains = testnet ? Object.values(orbitTestnets) : []

  return [...mainnetChains, ...testnetChains]
}
